import { render } from "./Info.vue?vue&type=template&id=eb6fdbbc&bindings={\"modals\":\"setup\",\"t\":\"setup\"}"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
script.render = render

export default script